<div class="content-wrapper">
        <div class="area-card-header">
          <h5 class="area-card-title">
      <mat-icon>account_tree</mat-icon>
      <span class="title-label">{{ title }}</span>
    </h5>

        <div class="area-card-actions">
      <button type="button" mat-raised-button class="header-button button-text" (click)="startCreateSection($event)">
        <mat-icon class="header-button-icon">add</mat-icon>
        Añadir Sección
      </button>

      <button type="button" mat-raised-button class="header-button button-text" (click)="startCreateProperty($event)">
        <mat-icon class="header-button-icon">add</mat-icon>
        Añadir Propiedad
      </button>

<button *ngIf="showSaveButton" mat-raised-button color="primary" (click)="onSaveClick()">
        {{ saveButtonLabel }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="!isEmpty; else emptyState">
    <div class="structure-container" cdkDropListGroup>
      <ng-container *ngTemplateOutlet="propertyTree; context: { $implicit: areaPropertyByHierarchy }">
      </ng-container>
    </div>
  </ng-container>

  <!-- 🔁 Plantilla recursiva -->
  <ng-template #propertyTree let-properties>
    <ul class="property-list" cdkDropList [cdkDropListData]="properties" [cdkDropListConnectedTo]="connectedDropLists"
      (cdkDropListDropped)="drop($event)">

      <ng-container *ngFor="let prop of properties">
      <li class="property-item"
          [class.is-section]="prop.inputType === 'section'"
          [class.is-list]="prop.inputType === 'list'"
          [class.drop-hover]="(prop.inputType === 'section' && hoverSectionId === prop.id) || (prop.inputType === 'list' && hoverListId === prop.id)"
          cdkDrag
          (cdkDragMoved)="onDragMoved($event, prop)"
          (cdkDragEnded)="onDragEnded()">

        <!-- 🖼️ Preview al arrastrar: fila en modo lectura con estilos inline garantizados -->
        <div *cdkDragPreview
             style="display:flex;align-items:center;gap:10px;background:#fff;border-radius:10px;
                    box-shadow:0 6px 20px rgba(0,0,0,0.18);padding:10px 16px;
                    cursor:grabbing;list-style:none;max-width:600px;">
          <mat-icon style="font-size:20px;color:#aaa;width:20px;height:20px;flex-shrink:0;">drag_indicator</mat-icon>
          <span *ngIf="prop.inputType === 'section'"
                style="font-weight:600;color:#1d5ed8;font-size:0.85rem;text-transform:uppercase;">Sección:</span>
          <span [style.font-weight]="prop.inputType === 'section' ? '700' : '500'"
                [style.color]="prop.inputType === 'section' ? '#1d3557' : '#222'"
                style="font-size:0.95rem;white-space:nowrap;">
            {{ prop.label | titlecase }}
          </span>
          <span *ngIf="prop.inputType !== 'section'"
                style="background:#ecf3ff;color:#1d5ed8;padding:2px 10px;border-radius:10px;
                       font-size:0.72rem;font-weight:700;text-transform:uppercase;flex-shrink:0;">
            {{ inputTypeLabels[prop.inputType] || prop.inputType }}
          </span>
          <span *ngIf="prop.value !== null && prop.value !== undefined && prop.value !== '' && prop.inputType !== 'section'"
                style="background:#e8f5e9;color:#2e7d32;padding:2px 8px;border-radius:8px;
                       font-size:0.75rem;font-weight:500;flex-shrink:0;">
            Valor: {{ prop.inputType === 'date' ? (prop.value | date:'dd/MM/yyyy') : getValueSummary(prop) }}
          </span>
          <span *ngIf="prop.unit"
                style="background:#fff4e5;color:#c87800;padding:2px 8px;border-radius:8px;
                       font-size:0.75rem;font-weight:500;flex-shrink:0;">
            Unidad: {{ prop.unit }}
          </span>
          <span *ngIf="prop.isRequired && prop.inputType !== 'section'"
                style="background:#ffe6e6;color:#c62828;padding:2px 8px;border-radius:8px;
                       font-size:0.75rem;font-weight:600;border:1px solid #ffb8b8;flex-shrink:0;">
            Obligatorio
          </span>
        </div>

        <!-- 🔄 Fila en modo EDICIÓN (solo si no está bloqueada para edición) -->
        <ng-container *ngIf="editingPropertyId === prop.id && !isEditDisabled(prop); else readNode">
          <div class="node editing" (click)="$event.stopPropagation()" [formGroup]="editForm">

            <!-- 🟦 CABECERA -->
            <div class="edit-header" cdkDragHandle>
              <mat-icon class="drag-handle"
                [ngClass]="{ 'section-drag': editForm.get('inputType')?.value === 'section' }">
                drag_indicator
              </mat-icon>
              <div class="header-center" (click)="$event.stopPropagation()">
                <mat-select formControlName="inputType" class="header-type-select" (selectionChange)="onInputTypeChange()">
                  <mat-option *ngFor="let type of propertyTypes" [value]="type">
                    {{ inputTypeLabels[type] }}
                  </mat-option>
                </mat-select>
              </div>

              <!-- Incluir en sección — en cabecera -->
              <div class="header-section-wrapper" (click)="$event.stopPropagation()">
                <mat-icon class="header-section-icon">folder_open</mat-icon>
                <mat-select formControlName="parentId" class="header-section-select" placeholder="Sin sección">
                  <mat-option [value]="null">Sin sección</mat-option>
                  <mat-option *ngFor="let sec of getAvailableSections(prop)" [value]="sec.id">
                    {{ sec.label }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="edit-header-actions">
                <!-- Desktop: flechas inline -->
                <button mat-icon-button class="btn-move hide-on-mobile" (click)="moveUp(prop, $event)" matTooltip="Subir">
                  <mat-icon>arrow_upward</mat-icon>
                </button>
                <button mat-icon-button class="btn-move hide-on-mobile" (click)="moveDown(prop, $event)" matTooltip="Bajar">
                  <mat-icon>arrow_downward</mat-icon>
                </button>

                <!-- Móvil: tres puntos -->
                <button mat-icon-button class="show-on-mobile" [matMenuTriggerFor]="moveMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #moveMenu="matMenu">
                  <button mat-menu-item (click)="moveUp(prop, $event)">
                    <mat-icon>arrow_upward</mat-icon>
                    <span>Subir</span>
                  </button>
                  <button mat-menu-item (click)="moveDown(prop, $event)">
                    <mat-icon>arrow_downward</mat-icon>
                    <span>Bajar</span>
                  </button>
                </mat-menu>
              </div>
            </div>

            <!-- 🟦 FILA 1: nombre, tipo, sección, valor por defecto, obligatorio -->
            <div class="edit-row edit-row-main">

              <!-- Nombre -->
              <mat-form-field appearance="fill" class="inline-field name-field">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="label" #nameInput (keydown.enter)="confirmPendingEdit()" />
              </mat-form-field>


              <!-- Valor por defecto (según tipo) -->
              <ng-container [ngSwitch]="editForm.get('inputType')?.value">

                <!-- TEXT -->
                <mat-form-field *ngSwitchCase="'text'" appearance="fill" class="inline-field value-field">
                  <mat-label>Valor por defecto</mat-label>
                  <input matInput formControlName="value" (keydown.enter)="confirmPendingEdit()" />
                </mat-form-field>

                <!-- NUMBER -->
                <mat-form-field *ngSwitchCase="'number'" appearance="fill" class="inline-field value-field">
                  <mat-label>Valor numérico</mat-label>
                  <input matInput type="number" formControlName="value" (keydown.enter)="confirmPendingEdit()" />
                </mat-form-field>

                <!-- BOOLEAN -->
                <div *ngSwitchCase="'boolean'" class="inline-boolean value-field">
                  <mat-slide-toggle formControlName="value" color="primary">
                    Valor por defecto
                  </mat-slide-toggle>
                </div>

                <!-- LIST: selector con las opciones -->
                <mat-form-field *ngSwitchCase="'list'" appearance="fill"
                  class="inline-field value-field list-default-field">
                  <mat-label>Valor por defecto</mat-label>
                  <mat-select formControlName="value">
                    <mat-option *ngFor="let opt of editForm.get('options')?.value || []" [value]="opt.value">
                      {{ opt.label || opt.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- DATE -->
                <mat-form-field *ngSwitchCase="'date'" appearance="fill" class="inline-field value-field">
                  <mat-label>Fecha por defecto</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="value" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </ng-container>

              <!-- Unidad (solo text / number) -->
              <mat-form-field appearance="fill" class="inline-field unit-field" *ngIf="
                  editForm.get('inputType')?.value === 'text' ||
                  editForm.get('inputType')?.value === 'number'
                ">
                <mat-label>Unidad</mat-label>
                <input matInput formControlName="unit" placeholder="Ej: cm, %, m²" (keydown.enter)="confirmPendingEdit()" />
              </mat-form-field>

              <!-- Obligatorio (no para secciones) -->
              <div class="inline-required" *ngIf="editForm.get('inputType')?.value !== 'section'">
                <mat-slide-toggle formControlName="isRequired" color="primary" (change)="onRequiredToggleChange()">
                  Obligatorio
                </mat-slide-toggle>
              </div>



              <!--
                🔮 A FUTURO — Toggle "Activar secciones por opción"
                Permite al admin elegir si una propiedad LIST genera automáticamente
                una sección hija por cada opción añadida (ej: Trigo → Sección Trigo).
                Actualmente siempre está activado (hasSectionPerOption = true para listas).
                Para reactivar:
                  1. Descomentar este bloque
                  2. Descomentar hasSectionPerOption en initForm() y startEdit()
                  3. En saveEdit(), leer del form en lugar de calcular fijo
              -->
              <!-- <div class="inline-required" *ngIf="editForm.get('inputType')?.value === 'list'">
                <mat-slide-toggle formControlName="hasSectionPerOption" color="primary">
                  Activar secciones por opción
                </mat-slide-toggle>
              </div> -->

            </div> <!-- /edit-row-main -->

            <!-- 🟦 FILA 2: Añadir opción (solo LIST) -->
            <div class="edit-row list-row-add" *ngIf="editForm.get('inputType')?.value === 'list'">
              <mat-form-field appearance="fill" class="inline-field new-option-input">
                <mat-label>Añadir opción</mat-label>
                <input matInput [(ngModel)]="newOptionText"  [ngModelOptions]="{standalone: true}"
 name="newOptionText" placeholder="Añadir opción..." (keydown.enter)="addListOption()" />

              </mat-form-field>

              <button mat-mini-fab color="primary" (click)="addListOption()" [disabled]="!newOptionText?.trim()">
                <mat-icon>add</mat-icon>
              </button>

            </div>

            <!-- 🟦 FILA 3: Chips con opciones (solo LIST) -->
            <div class="edit-row list-row-chips" *ngIf="editForm.get('inputType')?.value === 'list'">
              <div class="list-chips" *ngIf="(editForm.get('options')?.value || []).length; else noOptionsTpl">
                <div *ngFor="let opt of editForm.get('options')?.value; let i = index" class="list-chip">
                  <mat-icon *ngIf="opt.sectionAreaPropertyId" class="chip-section-icon" matTooltip="Sección vinculada">folder</mat-icon>
                  <span class="list-chip-text">
                    {{ opt.label || opt.value }}
                  </span>
                  <button mat-icon-button type="button" (click)="removeListOption(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>

              <ng-template #noOptionsTpl>
                <p class="list-empty-text">
                  No hay opciones añadidas todavía.
                </p>
              </ng-template>
            </div>

          </div>
        </ng-container>

        <!-- 🔍 Fila en modo LECTURA -->
        <ng-template #readNode>
          <div class="node"
               [class.readonly]="isEditDisabled(prop)"
               [class.active-section]="prop.inputType === 'section' && activeSectionId === prop.id"
               [attr.data-section-id]="prop.inputType === 'section' ? prop.id : null"
               [attr.data-list-id]="prop.inputType === 'list' ? prop.id : null"
               [cdkDragHandleDisabled]="!lockEnabled && isReadOnly(prop)" cdkDragHandle
               (click)="!isEditDisabled(prop) && startEdit(prop, $event)">
            <mat-icon class="drag-handle" [ngClass]="{ 'section-drag': prop.inputType === 'section', 'readonly': !lockEnabled && isReadOnly(prop) }">
              drag_indicator
            </mat-icon>

            <button mat-icon-button
                    *ngIf="prop.children?.length"
                    class="btn-collapse"
                    (click)="toggleNodeCollapse(prop, $event)"
                    [matTooltip]="getCollapseTooltip(prop)">
              <mat-icon>{{ isNodeCollapsed(prop) ? 'chevron_right' : 'expand_more' }}</mat-icon>
            </button>

            <!-- Prefijo SECCIÓN -->
            <span *ngIf="prop.inputType === 'section'" class="section-prefix-text" [ngClass]="{ 'section-label': prop.inputType === 'section' }">
              Sección:
            </span>

            <span class="label" [ngClass]="{ 'section-label': prop.inputType === 'section' }">
              {{ prop.label | titlecase }}
            </span>

            <span *ngIf="prop.inputType === 'section' && prop.children?.length && isNodeCollapsed(prop)" class="collapsed-badge hide-mobile">
              {{ getNodeContentCount(prop) }} elementos ocultos
            </span>

            <span *ngIf="prop.inputType === 'section' && prop.children?.length && isNodeCollapsed(prop)"
                  class="collapsed-badge collapsed-badge--mobile show-on-mobile">
              {{ getNodeContentCount(prop) }} Elem.
            </span>

            <!-- Origen de la propiedad -->
            <span *ngIf="prop.source === 'template'" class="source-badge source-template">Plantilla</span>
            <span *ngIf="prop.source === 'custom'" class="source-badge source-custom">Personalizada</span>

            <!-- Tipo → oculto si es sección -->
            <span class="type-badge" *ngIf="prop.inputType !== 'section'">
              {{ inputTypeLabels[prop.inputType] || prop.inputType }}
            </span>

            <!-- Valor con badge -->
            <span *ngIf="prop.inputType !== 'section' &&
                     prop.value !== null &&
                     prop.value !== undefined &&
                     prop.value !== ''" class="value-badge hide-mobile">
              Valor: {{ prop.inputType === 'date' ? (prop.value | date:'dd/MM/yyyy') : getValueSummary(prop) }}
            </span>

            <!-- Unidad -->
            <span *ngIf="prop.unit" class="unit-badge hide-mobile">
              Unidad: {{ prop.unit }}
            </span>

            <!-- Obligatorio -->
            <span *ngIf="prop.isRequired && prop.inputType !== 'section'" class="required-badge hide-mobile">
              Obligatorio
            </span>


            <!-- Candado: indicador visual cuando está bloqueada -->
            <mat-icon *ngIf="prop.isLocked" class="lock-indicator" matTooltip="Bloqueada para usuarios">
              lock
            </mat-icon>

            <!--
            <span class="order-circle">
              {{ prop.orderIndex }}
            </span>
            -->

            <div class="actions">
              <span *ngIf="prop.inputType !== 'section' && prop.children?.length && isNodeCollapsed(prop)"
                    class="collapsed-badge collapsed-badge--list hide-mobile">
                {{ getNodeContentCount(prop) }} elementos ocultos
              </span>

              <span *ngIf="prop.inputType !== 'section' && prop.children?.length && isNodeCollapsed(prop)"
                    class="collapsed-badge collapsed-badge--list collapsed-badge--mobile show-on-mobile">
                {{ getNodeContentCount(prop) }} Elem.
              </span>

              <!-- Pin: siempre visible -->
              <button mat-icon-button
                      *ngIf="prop.inputType === 'section'"
                      (click)="setActiveSection(prop.id, $event)"
                      [matTooltip]="activeSectionId === prop.id ? 'Deseleccionar sección' : 'Seleccionar sección'"
                      [class.pin-active]="activeSectionId === prop.id"
                      class="btn-pin">
                <mat-icon>push_pin</mat-icon>
              </button>

              <!-- Botones inline — solo desktop -->
              <ng-container class="desktop-actions">
                <button mat-icon-button class="hide-on-mobile"
                        *ngIf="!isEditDisabled(prop)"
                        (click)="duplicateProperty(prop, $event)"
                        matTooltip="Duplicar">
                  <mat-icon>content_copy</mat-icon>
                </button>

                <button mat-icon-button class="hide-on-mobile"
                        *ngIf="!lockEnabled"
                        [class.lock-active]="prop.isLocked"
                        (click)="toggleLock(prop, $event)"
                        [matTooltip]="prop.isLocked ? 'Desbloquear propiedad' : 'Bloquear propiedad'">
                  <mat-icon>{{ prop.isLocked ? 'lock' : 'lock_open' }}</mat-icon>
                </button>

                <button mat-icon-button color="warn" class="hide-on-mobile"
                        *ngIf="!isEditDisabled(prop)"
                        (click)="deleteProperty(prop, $event)"
                        matTooltip="Eliminar propiedad">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-container>

              <!-- Tres puntos — solo móvil -->
              <button mat-icon-button class="show-on-mobile"
                      [matMenuTriggerFor]="propMenu"
                      (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #propMenu="matMenu">
                <button mat-menu-item *ngIf="!isEditDisabled(prop)" (click)="duplicateProperty(prop, $event)">
                  <mat-icon>content_copy</mat-icon>
                  <span>Duplicar</span>
                </button>
                <button mat-menu-item *ngIf="!lockEnabled" (click)="toggleLock(prop, $event)">
                  <mat-icon>{{ prop.isLocked ? 'lock' : 'lock_open' }}</mat-icon>
                  <span>{{ prop.isLocked ? 'Desbloquear' : 'Bloquear' }}</span>
                </button>
                <button mat-menu-item *ngIf="!isEditDisabled(prop)" (click)="deleteProperty(prop, $event)" class="menu-item-danger">
                  <mat-icon color="warn">delete</mat-icon>
                  <span style="color: #f44336">Eliminar</span>
                </button>
              </mat-menu>
            </div>
          </div>

        </ng-template>

        <!-- 🔁 Hijos: solo secciones o props con hijos existentes (ej: list con secciones vinculadas) -->
        <div class="children"
             *ngIf="(prop.inputType === 'section' || (prop.children && prop.children.length)) && !(editingPropertyId === prop.id && (!prop.children || !prop.children.length)) && !isNodeCollapsed(prop)"
             [class.section-children-empty]="prop.inputType === 'section' && (!prop.children || !prop.children.length) && editingPropertyId !== prop.id"
             [attr.data-section-id]="prop.inputType === 'section' ? prop.id : null"
             [attr.data-list-id]="prop.inputType === 'list' ? prop.id : null">
          <ng-container [ngTemplateOutlet]="propertyTree"
            [ngTemplateOutletContext]="{ $implicit: prop.children || [] }">
          </ng-container>
        </div>
      </li>
      </ng-container>
    </ul>
  </ng-template>

  <!-- 🧩 Estado vacío -->
  <ng-template #emptyState>
    <div class="empty-state">
      <mat-icon>lightbulb_outline</mat-icon>
      <p>No se han añadido propiedades en ninguna sección.</p>
      <p class="hint">Añade una sección y sus propiedades.</p>
    </div>
  </ng-template>
</div>
